import type { Position, BonusType, PlayerId } from '../types';
import type { Letter } from './Letter';

export interface BoardCell {
  position: Position;
  letter: Letter | null; // null if empty
  playerId: PlayerId | null; // Who placed this letter
  wordIds: string[]; // IDs of words using this cell
  isOccupied: boolean; // Computed: letter !== null
  bonusType: BonusType | null; // Bonus square type (null if none)
}

/**
 * Create a new empty board cell
 */
export function createBoardCell(
  row: number,
  col: number,
  bonusType: BonusType | null = null
): BoardCell {
  return {
    position: { row, col },
    letter: null,
    playerId: null,
    wordIds: [],
    isOccupied: false,
    bonusType,
  };
}

/**
 * Place a letter on a board cell
 */
export function placeLetterOnCell(
  cell: BoardCell,
  letter: Letter,
  playerId: PlayerId,
  wordId: string
): BoardCell {
  return {
    ...cell,
    letter,
    playerId,
    wordIds: [...cell.wordIds, wordId],
    isOccupied: true,
  };
}
